import Vue from 'vue'
import Router from 'vue-router'
import search from '@/components/search';
import index from '@/components/container/index';
import enter from '@/components/enter';
import notFound from '@/components/404.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: search
    },
    {
      path: '/index',
      component: enter,
      children: [
        {
          path: "/index",
          component: index
        }
      ]
    },
    {
      path: '/404',
      component: notFound
    },
    {
      path: '*',
      redirect: '/index'
    }
  ]
})
